<script>
    import { alertState, closeAlert } from "/stores/alert.js";

    function handleKeydown(e) {
        if ($alertState.resolve && (e.key === "Enter" || e.key === "Escape")) {
            e.preventDefault();
            closeAlert();
        }
    }
</script>

<svelte:window on:keydown={handleKeydown} />

{#if $alertState.resolve}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div id="alert-overlay" class="alert-overlay" role="presentation" on:click|self={closeAlert}>
        <div id="alert-box" class="alert-box">
            <div id="alert-body" class="alert-body">{$alertState.message}</div>
            <div class="alert-footer">
                <button id="btn-confirm" class="buttonA" on:click={closeAlert}>확인</button>
            </div>
        </div>
    </div>
{/if}

<style>
    .alert-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 8vh;
        z-index: 10001;
    }

    .alert-box {
        background: #fff;
        border-radius: 8px;
        min-width: 300px;
        max-width: 500px;
        max-height: 40vh;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .alert-body {
        padding: 24px;
        font-size: 14px;
        line-height: 1.6;
        color: var(--gray-800, #333);
        overflow-y: auto;
        white-space: pre-wrap;
        word-break: break-word;
    }

    .alert-footer {
        padding: 12px 24px;
        display: flex;
        justify-content: flex-end;
        border-top: 1px solid var(--gray-200);
    }
</style>
